import { ConsultationRequestStatusType } from '../enums';

export class ConsultationRequestStatusTypeLookup {

    static get(): any[] {
        return [
            { label: 'All', value: null },
            { label: 'Pending', value: ConsultationRequestStatusType.Pending },
            { label: 'Assigned', value: ConsultationRequestStatusType.Assigned },
            { label: 'Confirm', value: ConsultationRequestStatusType.Confirm },
            { label: 'Reject', value: ConsultationRequestStatusType.Reject },
            { label: 'Closed', value: ConsultationRequestStatusType.Closed },
            { label: 'Release', value: ConsultationRequestStatusType.Release },
            { label: 'Arrive', value: ConsultationRequestStatusType.Arrive },
        ];
    }
}
